var _defs, _style, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _g2, _g3, _g4, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeProgram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 303 199",
    width: 303,
    height: 199,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "home-program-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m89 187h57v11.48h-57z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m203.21 52.19h23.46v18.16h-23.46z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m214.13 28.23c-6.88-9.44-19.23-6.39-20.11 9.22-0.27 4.79 0.89 6.67 1.93 9.44 0.28 0.73 0.52 1.63 0.76 2.55 0.75 2.86 1.01 5.37 1.42 7.7 1.23 7.1 2.01 10.24 2.01 10.24 0 0 5.16 3.66 15.18 2.38 6.61-0.84 15.22-7.86 15.22-7.86 0 0-5.59-18.82-16.41-33.67z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m194.51 44.24h18.92v18.16h-18.92z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m214.13 28.23c-6.88-9.44-19.23-6.39-20.11 9.22-0.27 4.79 0.89 6.67 1.93 9.44 0.28 0.73 0.52 1.63 0.76 2.55 0.75 2.86 1.01 5.37 1.42 7.7 1.23 7.1 2.01 10.24 2.01 10.24 0 0 5.16 3.66 15.18 2.38 6.61-0.84 15.22-7.86 15.22-7.86 0 0-5.59-18.82-16.41-33.67z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m202.46 29.1h27.24v23.09h-27.24z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m214.13 28.23c-6.88-9.44-19.23-6.39-20.11 9.22-0.27 4.79 0.89 6.67 1.93 9.44 0.28 0.73 0.52 1.63 0.76 2.55 0.75 2.86 1.01 5.37 1.42 7.7 1.23 7.1 2.01 10.24 2.01 10.24 0 0 5.16 3.66 15.18 2.38 6.61-0.84 15.22-7.86 15.22-7.86 0 0-5.59-18.82-16.41-33.67z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #f5f0df } \n\t\t.s1 { fill: #4e4059 } \n\t\t.s2 { fill: #ddc1a4 } \n\t\t.s3 { fill: #f4b68c } \n\t\t.s4 { fill: #e89e7e } \n\t\t.s5 { fill: #efe7d0 } \n\t\t.s6 { fill: #fcf8eb } \n\t\t.s7 { fill: #352d3d } \n\t\t.s8 { fill: #d1c29a } \n\t\t.s9 { fill: #ffd44d } \n\t\t.s10 { fill: #ffb94a } \n\t\t.s11 { fill: #9ad4ba } \n\t\t.s12 { fill: #d3c7a7 } \n\t\t.s13 { fill: #d3a532 } \n\t\t.s14 { fill: #d39030 } \n\t\t.s15 { fill: #7fa57a } \n\t\t.s16 { fill: #ea9836 } \n\t\t.s17 { fill: #ffbe91 } \n\t\t.s18 { fill: #ffffff } \n\t\t.s19 { fill: #ea907e } \n\t\t.s20 { fill: #4fa2bf } \n\t\t.s21 { fill: #8e603f } \n\t\t.s22 { fill: #7f3633 } \n\t\t.s23 { fill: #af8066 } \n\t\t.s24 { fill: #7f5f4f } \n\t\t.s25 { fill: #7fd7e5 } \n\t\t.s26 { fill: #7c5549 } \n\t\t.s27 { fill: #a3544a } \n\t\t.s28 { fill: #c66a5c } \n\t\t.s29 { fill: #d8c8a0 } \n\t\t.s30 { fill: #d8915b } \n\t\t.s31 { fill: #f0aa71 } \n\t\t.s32 { fill: #e26949 } \n\t\t.s33 { fill: #b29072 } \n\t\t.s34 { fill: #cf776b } \n\t\t.s35 { fill: #e8dec4 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m101.5 187.2c-0.7 0-10.6 4.2-11.7 6.1-1.2 1.8 12.7 4.8 23.1 5 10.4 0.2 29.1-1.1 31.8-2.6 2.8-1.4-13.2-6.3-24.4-6.3-11.2 0-18.8-2.2-18.8-2.2z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m126.9 174.2c0 0 15.4 2.4 18.2 1.9 2.8-0.5 13-0.7 15.1 0.4 2.1 1.2 24 0.5 26.2-0.3 2.1-0.7-0.2-2.5 9.2-4.7 9.4-2.2 34.7-1.2 39.1-0.5 4.3 0.8 12 1.4 11 4.4-1 3 3.4 6.4 14.7 5.5 11.2-0.9 29.2-1.4 36.3-1.2 7.2 0.1 9 2.7 2 4.2-7.1 1.5-45.6 8.3-51.4 8.5-5.8 0.2-76.5 2.2-86.4 2-9.8-0.1-48.9-9.4-44.9-14 4.1-4.5 10.9-6.2 10.9-6.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m68 180.5c0 0 13.5 2.1 15.8 2.6 2.3 0.4-4.6 3.1-17.7 3.3-13.1 0.2-26.9-0.2-34.9 0-8.1 0.2-27.6 0.3-30.1-1.5-2.5-1.7 1.8-4.7 10.9-4.4 9.1 0.3 32.5-0.2 37.8 0 5.2 0.2 18.2 0 18.2 0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m241.3 178.9c-2.5-0.2-4.4-1-4.2-2.3q0.1-0.2 0.2-0.3c0.6-0.5 6.9-3.4 7.8-4.2 1-0.7 1.8-1.1 2.9-1.1 1 0 3.7-0.8 4.6-0.7 0.9 0.2 0.8 0.8 0.9 1.6 0.1 0.7 0.2 1.9 0.2 2.6-1.3 0.4-4.7 1.5-5.8 2.2-1.3 0.8-4 2.4-6.6 2.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m237.1 176.6c-0.2 1.3 1.7 2.1 4.2 2.3 2.6 0.2 5.3-1.4 6.6-2.2 1.1-0.7 4.5-1.8 5.8-2.2v0.1c0.1 0.7-0.5 2-0.5 2-0.3 0.5-0.8 0.3-1.8 0.7-1 0.4-2.8 1.2-4.7 2.4-2 1.1-4.5 1.4-6 1.1-1.4-0.3-3.4-0.9-4-1.7-0.6-0.6-0.1-1.9 0.4-2.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m246.4 166.4c-1 0.4 1 3.6 0.2 4.4-0.4 0.4-0.7 0.8-0.9 1-0.2 0.4 0.3 0.8 2.2 0.6 2-0.1 4.6-1.3 4.7-1.5 0.1-0.1-1.2-4.6-2.2-5.1-0.5-0.2-2.9 0.3-4 0.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m227.8 26.1c0 0 0.9-0.6 0.9-2-0.1-1.4-1.1-3.8-2-2.9-0.9 0.8-0.9 4.4 1.1 4.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m279.3 179c-2.6 0.1-4.6-0.6-4.6-1.9q0-0.2 0.1-0.3c0.5-0.6 5.4-3.4 5.7-4.5 0.2-1.2 0.6-2 1.6-2.7 0.9-0.6 2.5-2.9 3.3-3.4 0.9-0.5 1.2 0.1 1.8 0.6 0.6 0.6 1.4 1.4 1.9 2-0.8 1.1-2.9 4.1-3.3 5.3-1.4 4.2-3.8 4.9-6.5 4.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m274.7 177.1c0 1.3 2 2 4.6 1.9 2.7 0 5-1.2 6.5-4.9 0.5-1.1 2.5-4.2 3.3-5.3l0.1 0.1c0.5 0.5 0.9 1.5 0.9 1.5 0.1 0.6-1 1.6-1.5 2.6-0.6 0.9-1.5 2.2-2.3 4.3-0.8 2.1-5.7 3.9-7.3 3.7-1.5-0.1-3.7-0.5-4.4-1.2-0.7-0.7-0.4-2 0.1-2.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m280 163.6c-0.8 0.9 0.8 8.1 0.8 8.4 0 0.5 0.6 0.6 2.4-0.6 1.8-1.1 3.5-3.6 3.6-3.8 0-0.1-2.1-5.6-2.8-5.6-0.6 0.1-3.2 0.7-4 1.6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m170.7 62.5c-0.5-2.3-1.1-5.8-1.6-9.7-1.6 0.8-4.3 1.9-8.2 2.6 0 3.8 0.4 7.6 1.5 11.4 2.4 8.4 8.4 22 13.1 25.9 1.3 1.1 2.5 0.6 3.5-0.1 2.9-1.7-6.4-22.6-8.3-30.1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m231.6 168.7c-3.1 0-5.4 2.7-5.7 2.9-0.4 0.2-5.2 0.7-6.9 0.2-1.7-0.5-2.1-2.5-2.7-2.7-0.2-0.1-0.6-0.1-0.8-0.1q-0.1 0.1-0.2 0.3c-0.2 0.5-0.5 0.8-0.4 1.5 0.1 0.8 1.2 1.3 2.5 1.7 1.4 0.5 3.4 0.9 5.1 0.8 1.8-0.1 3.3-0.7 3.8-1.2 0.5-0.5 0.3-0.6 1.1-0.7 0.7-0.2 1 0.4 2.2 0.4 1.3 0 2-0.5 2.3-1.4 0.1-0.5 0-1-0.2-1.4q0-0.1-0.1-0.3z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m216.3 169.1c0.6 0.2 1 2.2 2.7 2.7 1.7 0.5 6.5 0 6.9-0.2 0.3-0.2 2.6-2.9 5.7-2.9q-0.2-0.5-0.2-1.1c-0.1-1-0.3-2.8-0.9-3.3-0.6-0.8-3.4-1.3-5.7-0.9q-0.9 0.1-1.6 0.7c-1 0.9-3.1 2.7-3.7 3.1-0.9 0.6-2.6 1.3-3.2 1.5-0.4 0.1-0.6 0.1-0.8 0.3 0.2 0 0.6 0 0.8 0.1z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m232.3 132.6c0.9 5.8-1.8 25.4-2.5 30.9-0.2 0.9-0.9 1.4-1.7 1.4l-2.8-0.3c-0.5 0-0.9-0.4-0.9-0.8-0.5-3.6-2.3-16.6-4.1-30.4z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m213.5 168.7c-3.1 0-5.5 2.7-5.8 2.9-0.3 0.2-5.1 0.7-6.8 0.2-1.8-0.5-2.1-2.5-2.7-2.7-0.3-0.1-0.6-0.1-0.9-0.1q0 0.1-0.1 0.3c-0.2 0.5-0.5 0.8-0.4 1.5 0.1 0.8 1.2 1.3 2.5 1.7 1.3 0.5 3.3 0.9 5.1 0.8 1.7-0.1 3.3-0.7 3.8-1.2 0.5-0.5 0.2-0.6 1-0.7 0.8-0.2 1 0.4 2.3 0.4 1.3 0 2-0.5 2.2-1.4 0.1-0.5 0-1-0.1-1.4q-0.1-0.1-0.1-0.3z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m198.2 169.1c0.6 0.2 0.9 2.2 2.7 2.7 1.7 0.5 6.5 0 6.8-0.2 0.3-0.2 2.7-2.9 5.8-2.9q-0.2-0.5-0.3-1.1c0-1-0.3-2.8-0.8-3.3-0.7-0.8-3.5-1.3-5.8-0.9-0.5 0-1.1 0.3-1.5 0.7-1.1 0.9-3.1 2.7-3.8 3.1-0.8 0.6-2.5 1.3-3.1 1.5-0.5 0.1-0.7 0.1-0.9 0.3 0.3 0 0.6 0 0.9 0.1z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m214.1 132.6c0.9 5.8-1.7 25.4-2.5 30.9-0.1 0.9-0.8 1.4-1.6 1.4l-2.8-0.3c-0.5 0-0.9-0.4-1-0.8-0.5-3.6-2.3-16.6-4-30.4z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m199.2 27.8c-4.4-1.1-7.5 16.6-10.2 24.2l9.1 4.5c4.3-7.9 6-27.6 1.1-28.7z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m226.9 61.9c0 0 5.4 4.7 5.4 20.1-0.1 5.5 5.3 26.5 4.9 47.2-0.4 13.9-2.6 30.9-2.6 30.9l-17.7 0.5c0 0-1.2-50.2-2-53.9-0.9-3.7-5.9-26.3-6.4-31.2-0.5-4.9-0.2-8.7-0.2-8.7z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m201.1 65.2c0 0-1.4 12.9-1.5 17.2-0.6 19.4 2.4 77.6 2.4 77.6 0 0 9.3 2.2 12.4 0.4 0 0 4.2-49.4 4.2-52.3 0-3-1-28.3-1.1-34.5-0.2-6.2-3.4-8.4-3.4-8.4z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m216.2 136.2c-0.1 0-0.2-0.1-0.2-0.2 0-0.1 0.2-10-0.5-14-0.3-1.7-0.9-7.5-1.6-14.1-0.9-9.5-2.1-21.4-2.9-24.8-1.2-5.6-1.5-9.4-1.5-9.5 0-0.1 0.1-0.2 0.2-0.2 0.2 0 0.3 0.1 0.3 0.2 0 0 0.3 3.8 1.5 9.4 0.8 3.5 1.9 14.8 2.9 24.8 0.7 6.7 1.3 12.4 1.6 14.1 0.7 4.1 0.5 13.7 0.5 14.1 0 0.1-0.1 0.2-0.3 0.2z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m210.6 80.1q-0.1 0-0.2 0l-3.5-3c-0.1-0.1-0.1-0.3 0-0.4 0-0.1 0.2-0.1 0.3 0l3.6 3c0.1 0.1 0.1 0.2 0 0.3q-0.1 0.1-0.2 0.1z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m210.8 81.1h-0.1l-3.7-1.6c-0.2-0.1-0.2-0.2-0.2-0.4 0.1-0.1 0.2-0.1 0.4-0.1l3.7 1.6c0.1 0.1 0.2 0.2 0.1 0.4q-0.1 0.1-0.2 0.1z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m230.2 67.8c-1.5-4.3-3.3-5.9-3.3-5.9l-9.7 2.6-13.2 4.6c0 0 1.7 1.8 7.1 2.3 5.4 0.4 14.9-1.9 17-2.7 0.7-0.2 1.5-0.6 2.1-0.9z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s8",
    d: "m198 56.4l-3.1-1.5v-11.1q0.5 1.6 1.1 3.1 0 0-0.1 0 0.1 0 0.1 0c0.2 0.7 0.5 1.6 0.7 2.5 0.7 2.6 1 4.9 1.3 7z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m214.1 28.2c-6.8-9.4-19.2-6.4-20.1 9.2-0.3 6.1 3 10.7 3.5 14.6 1.4 12.5 2.6 15.4 2.6 15.4 0 0 5.2 3.6 15.2 2.4 6.6-0.9 15.2-7.9 15.2-7.9 0 0-5.6-18.8-16.4-33.7z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s9",
    d: "m203.9 71.5c0 0-0.9-8 0-10.4 0.9-2.3 3.2-4.4 3.2-4.4l6-4.5c0 0-2 6.7-2.2 7-0.2 0.3-3 4.8-3 4.8l-0.4 2.4c0 0 2.5-3.2 3-4 0.4-0.8 3.2-3.1 6.3-3.1 3-0.1 8.9 2.2 8.9 2.2 0 0-7.9 1-8.5 1.2-0.7 0.2-4.3 4.3-4.3 4.3l7.2-1.2 6.5-0.4c0 0-5 5-7.5 5.7-2.5 0.6-11.9 2.4-15.2 0.4z"
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s10",
    d: "m196 62.3c0 0 3.5-8.3 4-9 0.5-0.8 1.9-4.1 1.9-4.1l11.5-1.3c0 0-8.8-3.2-9.7-3.4-0.9-0.1-5 0.1-6.6 0.7-1.7 0.6-3.8 10.2-1.1 17.1z"
  })))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m225.9 40.3c0 0-4.4-2.2-7.1-4.1-2.8-1.9-11.1-6.2-13.7-6.6-2.6-0.4-2.6-0.4-2.6-0.4 0 0 3.7 5.9 7.6 8.1 4 2.1 6.5 3.4 6.5 3.4 0 0-3.6-0.6-4.9 0.2-1.3 0.8-3.3 2.2-3.3 2.2h5.8c0 0 4.7 1.1 5.8 1 1.2 0 2.8 0 2.8 0 0 0-5.6 3.7-6.3 4.3-0.7 0.5-2.3 3.8-2.3 3.8 0 0 6.2-2.4 9.4-3.4 3.1-0.9 6.8-1 6-3.6-0.9-2.6-3.7-4.9-3.7-4.9z"
  })))))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m198.9 62.2q-0.2-1-0.3-2.1 0.1 1.1 0.3 2.1z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s8",
    d: "m202 68.4c-1.2-0.6-1.8-1-1.9-1 0-0.1-0.5-1.3-1.2-5.2q-0.2-1-0.3-2.1l7.5-11.3 4.6-0.6c-0.5 2.4-1.3 5-2.2 7.5l-1.4 1c0 0-2.3 2.1-3.2 4.4-0.4 1-0.4 2.8-0.4 4.7q-0.8 1.4-1.5 2.6zm9-21.4c-0.9-0.3-2-0.7-3-1.1l1.9-2.8h1.9c-0.2 1.1-0.5 2.5-0.8 3.9zm0.2-5.8l1.2-1.9c0 0 0 0.5-0.2 1.4q-0.3 0.1-0.5 0.2-0.3 0.2-0.5 0.3z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m203.5 65.8c0-1.9 0-3.7 0.4-4.7 0.9-2.3 3.2-4.4 3.2-4.4l1.4-1q-0.6 1.5-1.3 3c-1.3 2.6-2.6 5.1-3.7 7.1z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s14",
    d: "m206.1 48.8l1.9-2.9c1 0.4 2.1 0.8 3 1.1q-0.1 0.6-0.3 1.2z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m211.8 43.1h-1.9l1.3-1.9q0.2-0.1 0.5-0.3 0.2-0.1 0.5-0.2-0.1 0.9-0.4 2.4z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s16",
    d: "m194.5 10.8c0 0-1.7 1-1.6 2.7 0 1.7 0.9 2.4 0.9 3.3-0.1 0.9-0.8 2.9 0.1 3.8 0.8 0.9 1.4 0.4 1.5 1.6 0.2 1.2-0.3 2.3 1.1 2 1.4-0.3 5.4-1.2 5.2-4.1-0.2-2.8-5-11.1-7.2-9.3z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m202.9 15.6c0 0 2.7 6.8 3.2 8.3 0.2 0.6-4.2 3.5-4.3 2.6-0.2-1.6-2.1-8.6-2.1-8.6z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m204.9 23c0 0 1.3 0.1 1.8 1 0.8 1.2-4.9 10.2-6 10-1.4-0.3-1-8.9 0.8-10.1 1.8-1.2 3.4-0.9 3.4-0.9z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m198.6 8.5c1.8-0.1 3.5 1 4 2.8 0.9 2.6 1 4 0.1 5.6-0.9 1.8-3.2 3.6-4.8 3.6-1.8 0-2.8-0.8-3.3-2.6-0.3-1.2-0.2-1.9-0.3-2.4-0.3-1.3-1.5-5.8 0.9-6.4 1-0.3 2.2-0.5 3.4-0.6z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s18",
    d: "m195 17.4c0 0 1.3 0 2.9-0.5 0 0 0.1 1.1-1 1.4-1.1 0.3-1.9-0.9-1.9-0.9z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m199.2 14.3c0 0-0.8-0.1-1.2 0-0.3 0.1-0.3 0.3-0.4 0.3q0 0.1 0 0.1-0.1 0-0.1-0.1c0 0 0-0.4 0.5-0.5 0.4-0.1 1.2 0.1 1.2 0.1q0.1 0 0.1 0.1z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m195.5 15h-0.1c0 0-0.5-0.2-0.7 0.1q-0.1 0.1-0.1 0.1-0.1-0.1-0.1-0.2c0.3-0.4 0.8-0.3 1-0.2q0 0.1 0 0.1z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m196.5 14.9c-0.1-0.1-0.2-0.1-0.2 0-0.1 0.2-0.3 0.6-0.6 1-0.5 0.5-0.4 1 0.4 0.8 0.7-0.3 0.8-0.4 0.7-0.8-0.1-0.3-0.2-0.7-0.3-1z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m199 13.1h-0.1c-0.7-0.1-1.7 0.1-1.7 0.1q-0.1 0-0.1-0.1 0-0.1 0.1-0.1c0 0 1-0.2 1.8 0q0.1 0 0.1 0.1z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m194.2 14.5h-0.1q0-0.1 0-0.1 0.3-0.4 0.8-0.8 0.1-0.1 0.1 0 0.1 0.1 0 0.1-0.5 0.4-0.8 0.8z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m200.1 19.9c-0.1 0.1-0.2 0-0.3 0 0-0.1 0-0.3 0.1-0.4 0 0 1-0.6 1.4-1 0-0.1 0.2-0.1 0.3 0 0.1 0 0.1 0.2 0 0.3-0.4 0.4-1.4 1.1-1.4 1.1z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s16",
    d: "m195.9 10.1c0 0 6.4 2 6.7 2.3 0.4 0.2-0.1 7.2 0.1 8.5 0.2 0.9 1.3 2.1 4.1-0.4 0.7-0.6 0.5 1.4 2.8-0.9 0.6-0.6 0.3-2.2 0.7-2.6 1.7-1.6 0.6-2.4-0.3-3.2-1.1-1.2-1.4-1.7-1.5-2.4-0.3-1.2-0.6-2-2.2-2.4-0.7-0.2-0.7-2.5-3-2.3-2.3 0.2-2.8-2.5-4.9-1.1-2.6 1.8-3.3 3.1-2.5 4.5z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m193.6 10.3c0 0 0.1-0.9 1.3-1.4 1.3-0.6 2.3-0.5 4.1 0.1 1.7 0.5 3.6 3.1 4.1 2.9 0.5-0.2-1.5-3.3-2.5-4.4-1-1.2-3-2.3-5.1-1.5-4.1 1.7-2.2 5-1.9 4.3z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s16",
    d: "m200.3 11.1c0 0 0.5 0.7 0.6 1.6 0.1 0.9 0.3 1.9 0.7 1.6 0.3-0.3 0.9-2.1 0.6-2.6-0.3-0.5-1.9-0.6-1.9-0.6z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m201.9 13c0.1-0.4 0.3-0.9 0.6-1.1 0.3-0.3 0.8-0.5 1.3 0.2 1 1.4-0.5 4.5-1.4 3.6-0.7-0.6-0.6-1.9-0.5-2.7z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m202.8 15.3l-0.1-0.1c0 0-0.3-0.5-0.1-0.8 0.1-0.1 0.3-0.2 0.4-0.2 0.2-0.1 0.3-0.1 0.3-0.2 0.1-0.3 0.2-0.8 0-1.2-0.1-0.3-0.4-0.3-0.4-0.3q-0.1 0-0.1-0.1 0-0.1 0.1-0.1c0 0 0.4 0 0.6 0.4 0.1 0.5 0.1 1.1 0 1.3-0.1 0.2-0.2 0.3-0.4 0.3-0.2 0.1-0.3 0.1-0.4 0.2-0.1 0.2 0.2 0.6 0.2 0.6q0 0.1-0.1 0.1z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s16",
    d: "m196 9.6c0 0-2 4.1-2.4 4-0.4-0.1-0.8-2.4-0.3-3.4 0.6-1.1 2.1-1.8 2.5-1.6 0.4 0.2 0.2 1 0.2 1z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m191.5 53.2c-0.3 2-19.1 24-17.5 26.5 1.6 2.4 23.8-18.3 25-23z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m196 55.5c-2.2 3.5-21.1 22.3-19.8 24.9 1.3 2.6 20.2-6.4 26-16.9 1.2-2.3 2.5-5 3.8-7.8-4.8-0.1-8-2.5-8.9-3.3-0.6 1.8-1 3-1.1 3.1z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m209.9 28c-4.4-1.7-10.4 16.8-12.8 24.4 0.9 0.8 5.2 4.2 10 4.3 5.1-11.4 8.3-26.6 2.8-28.7z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s9",
    d: "m210 42.5l-5.4 0.3-4.5 0.7c-0.6 1.6-1.2 3.2-1.6 4.7 2.2-0.3 4.3-0.7 5.2-1 2.2-0.6 6.3-4.7 6.3-4.7z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s9",
    d: "m209.2 39.3c0 0-4.1-1.7-6.7-1.9q-0.8 1.9-1.6 3.9c0.5-0.5 1-1 1.2-1 0.6-0.2 7.1-1 7.1-1z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s20",
    d: "m166.9 30.3c0 0-5.1 10.5-5.9 22.7 3.7-0.7 6.3-1.7 7.9-2.5-1.2-9.4-2-20.2-2-20.2z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s18",
    d: "m161 53q-0.1 1.2-0.1 2.4c3.9-0.7 6.6-1.8 8.2-2.6q-0.1-1.1-0.2-2.3c-1.6 0.8-4.2 1.8-7.9 2.5z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m155.2 174.2c0.3 0.4 0.8-1.7 1.9-2.1 0.8-0.3 1.9-1.1 3.1-1.1v-0.1c-0.3-0.9 0-5.3 0-5.3l-6.5 0.6c0 0 0.7 3.5-0.3 5.9 0.3 0 1.5 1.7 1.8 2.1z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m166.2 178c-2.9-2.7-5.3-4.6-6-7-1.1-0.5-2.6-0.5-4 0.5-0.9 0.7-0.7 3.1-1 2.7-0.3-0.4-0.2-1.5-0.9-2.3-0.3-0.3-0.6-0.4-0.9-0.4 0 0.5-0.3 0.9-0.4 2-0.1 0.3-0.1 4-0.1 4l2.1 0.4c0 0 3.1 1.7 8.9 3.6 3.4 1.1 4.8-1.2 2.3-3.5z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m126.9 174.2c-0.4 0.4-0.9-1.7-1.9-2.1-0.8-0.3-1.9-1.1-3.1-1.1v-0.1c0.3-0.9 0-5.3 0-5.3l6.5 0.6c0 0-0.7 3.5 0.2 5.9-0.2 0-1.4 1.7-1.7 2.1z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m115.9 178c2.9-2.7 5.3-4.6 6-7 1.1-0.5 2.5-0.5 4 0.5 0.9 0.7 0.6 3.1 1 2.7 0.3-0.4 0.2-1.5 0.8-2.3 0.4-0.3 0.7-0.4 0.9-0.4 0.1 0.5 0.4 0.9 0.5 2 0.1 0.3 0.1 4 0.1 4l-2.1 0.4c0 0-3.2 1.7-8.9 3.6-3.4 1.1-4.9-1.2-2.3-3.5z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s21",
    d: "m85.1 29.1c0 0-2.5 4.4-5.4 7.5-5.2 5.6-11.9 14.4-9.5 19.8 2.4 5.3 11.2 1.2 13.5-0.9 2.3-2.1 10.7-15.1 10.2-19.6-0.5-4.5-5.7-11.3-8.8-6.8z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s10",
    d: "m96.1 37.6c4.7 5.1 7.2 22.9 9.5 28.8 1.4 3.6 14.8 28.3 9.1 28.9-1 0.1-4.4 2-6.3-0.4-4-5-7.5-17.4-11.5-26.8-4.8-11.7-7.1-23.7-5.9-26.7 0.8-1.8 2.6-6.5 5.1-3.8z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s21",
    d: "m99.8 21.3c0 0 0.5 0.3 0.6 2.2 0.1 1.8-2.6 12.1-5.8 14.4-3.2 2.2-8.3-1.1-8.2-3.5 0.1-2.5 8.1-17.5 13.4-13.1z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m18.1 139.9c0 0-4 1.5-5.9 3.7-2 2.1-2.7 4-3.1 5.4-0.4 1.4-0.5 3.2-1.4 3.8-0.8 0.5-1.6-4-1.9-5.4-0.2-1.4 0.1-3.2 0.4-4.1 0.3-1 0.5-2.8 0.5-2.8l-0.9 0.3 0.3-4 1.9-0.8c0 0 1.6-0.9 2.8-0.9 1.1-0.1 1 0.1 2.5 0 1.5-0.2 4.8-1.4 4.8-1.4 0 0 0.4 4.6 0 6.2z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m65.2 170c0 0-0.1 4.1 1.1 6.3 1.3 2.2 2.8 3.2 4 3.8 1.1 0.5 2.7 0.9 2.9 1.8 0.2 1-4.3 1.1-5.7 1.2-1.4 0-3-0.5-3.8-0.9-0.7-0.5-2.3-0.9-2.3-0.9l-0.2 1-3.6-0.9 0.1-2c0 0-0.3-1.7 0.1-2.9 0.5-1.1 0.6-1 1-2.5 0.5-1.4 0.7-4.9 0.7-4.9 0 0 4.4 0.3 5.7 0.9z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s23",
    d: "m146.2 78.3c0 0 19.1-0.6 19.3 1.2 3.3 37.1-3.5 82.8-4.1 88.7-0.1 0.6-9.1 0.9-9.3 0-0.3-1.9-2.1-15.2-2.9-27.9-1.8-26.7-3-62-3-62z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s23",
    d: "m150.2 79.1c0 0-21.6-2.7-21.7-0.9-3.4 37.2-6.5 84.8-5.8 90.8 0 0.5 12.4 0.6 12.6-0.3 1.1-6 14.9-89.6 14.9-89.6z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m166 87.3q-0.1-2.5-0.3-5l-28.4 0.2c0 0 4 2.6 12.6 3.3 5.9 0.5 12.5 1.1 16.1 1.5z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s25",
    d: "m153.8 20.1c0 0-7.3-1.1-13.3 2-5.5 2.8-8.3 16.4-9.6 27.5-0.9 8.1-1 17.1-4.2 29.3-0.8 3.4 12.9 4.5 22.7 5.3 15.5 1.4 17.9-0.7 17.8-1.9 0-0.5-2.8-13.2-2.3-23.3 0.2-5 4.6-21.6 2-28.7-1.5-3.9-3.7-9.3-13.1-10.2z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s26",
    d: "m150.5 10c0 0-0.2 0.8 0.4 2.3 0.6 1.5 0.8 2.5 1.8 2.5 0.9 0 1.7-4.2 1.3-5.4-0.4-1.2-2.5-0.9-3.5 0.6z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m155.5 4.4c-1.7 0.2-3.1 1.5-3.4 3.2-0.3 2.6-0.3 5.1 0.1 5.8 0.9 1.7 5.1 2.9 6.9 2.4 1.1-0.4 1.3-1.5 1.5-3.2 0.1-1.2-0.1-2.1-0.1-2.6 0.1-1.3 0.7-5.3-1.7-5.6-1-0.1-2.2-0.1-3.3 0z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m152.6 10.7c0 0-4.1 8.8-3.8 9.3 0.2 0.5 4.2 2.9 5 2.6 0.3-0.1 0.5-2 1-3.9 0.6-2.3 1.3-4.8 1.3-4.8z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m155.8 9.5q-0.1 0-0.2-0.1c0-0.1 0.1-0.1 0.1-0.1 0.1 0 0.5-0.1 0.9-0.1 0.3 0 0.4 0 0.5 0 0 0 0.1 0.1 0.1 0.1 0 0.1-0.1 0.1-0.1 0.2 0 0-0.2 0-0.5 0-0.4-0.1-0.8 0-0.8 0z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m160.2 9.4c-0.5-0.2-1 0-1 0-0.1 0-0.2 0-0.2-0.1q0-0.1 0.1-0.2c0 0 0.7-0.1 1.2 0q0.1 0.1 0 0.2 0 0.1-0.1 0.1z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s26",
    d: "m149.2 5.6c0.3-2.2 1.2-3.2 2.5-3.5 1-2.4 10-2.2 8.8 3.3-0.1 0.7-2 0.3-3.7 0.6-1.3 0.2-2.6 0.9-2.9 1.2-0.7 0.5-0.4 2.4-0.9 3-0.5 0.6-1.9 0.6-2.3 0.2-1.2-1-1.6-4.1-1.5-4.8z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m155.4 8.3q0 0-0.1-0.1 0-0.1 0.1-0.2c1.1-0.3 2.1-0.3 2.1-0.3q0.1 0 0.1 0.2c0 0 0 0.1-0.1 0.1 0 0-1-0.1-2 0.3z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s26",
    d: "m161 11.6c0 0-0.6-0.1-0.8-0.1-0.2 0-1 0.2-1 0.2 0 0-1.1-0.4-1.6-0.1-0.8 0.5-1.1 0.1-1.1 0.1 0 0-0.2 0.3 0.2 0.6-0.2 0-0.3 0-0.5 0.3-0.5 0.5-1 0.3-1.5 0-0.5-0.3-1.5-2.1-1.7-2.5-0.1-0.3-0.4 0-0.6 0.2-0.1 0.3-0.1 2.3 0 2.8 0.1 0.5-0.4 1.6 0.2 2.3 0.6 0.8 2.1 1.7 3.7 1.9 3.1 0.3 3.3-0.7 3.9-1.2 1.6-1.2 0.6-4 0.6-4z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s27",
    d: "m230.2 42.6c-1-4.6-6.8-5.6-8.8-2.6l-12.5 31c0 0-0.4 1.1-1.1 2.9l11 1.6c5.2-10.8 12.1-29.9 11.4-32.9z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m160.5 8.2h-0.1l-1.1-0.2q-0.1-0.1-0.1-0.2c0 0 0.1-0.1 0.1-0.1l1.2 0.3q0.1 0 0.1 0.1 0 0.1-0.1 0.1z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s18",
    d: "m160.5 12.4c-0.4 0.8-0.9 1.3-1.6 1.4-1.2 0-1.5-1.3-1.5-1.3z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m152.3 9.7c-0.1-0.3-0.4-0.6-0.8-0.7-0.3-0.1-0.8 0-1.1 0.6-0.5 1.3 1.6 3.3 2.2 2.3 0.4-0.7 0-1.7-0.3-2.2z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s28",
    d: "m152.1 11.7h-0.1q-0.1 0 0-0.2c0 0 0.1-0.3-0.1-0.4 0 0-0.1 0-0.3 0-0.1 0-0.3 0-0.4-0.1-0.2-0.2-0.4-0.6-0.3-1 0-0.5 0.4-0.6 0.4-0.6q0.1 0 0.1 0.1 0 0.1-0.1 0.2c0 0-0.2 0-0.2 0.3 0 0.3 0.1 0.7 0.3 0.8 0 0.1 0.1 0.1 0.2 0.1 0.2-0.1 0.3-0.1 0.5 0 0.2 0.2 0.2 0.5 0.1 0.7q0 0.1-0.1 0.1z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m156.6 9.3c0 0-0.3 0-0.3 0.1-0.1 0.1-0.2 0.2-0.1 0.5 0 0.4 0.5 0.3 0.6 0.2 0.1-0.2 0.3-0.6-0.2-0.8z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m159.7 9.2q-0.1 0-0.1 0c-0.1 0.1-0.2 0.3-0.2 0.6 0.1 0.5 0.5 0.4 0.5 0.2 0.1-0.1 0.3-0.6-0.2-0.8z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s28",
    d: "m158.6 9.8c0-0.1 0.1-0.1 0.2 0 0.1 0.2 0.4 0.5 0.9 0.8 0.6 0.5 0.6 1-0.3 0.8-0.9-0.1-1-0.1-1-0.6 0-0.3 0.1-0.7 0.2-1z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m265 67.6c0 0 8.4 11.4 10.3 21.2 1.8 9.7 11.8 75.1 11.8 75.1 0 0-1.2 2.6-3.6 3.9-2.8 1.4-5.8 1.6-5.8 1.6 0 0-4.2-13.7-10.5-34.1-1-3.4-6.3-16.8-6.5-17.6-1.3-6.4-8.5-25.5-10.5-30.4-2-4.9-2.9-8.9-2.9-8.9z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m238.4 80.7l3.2 87.9c0 0 7.8 1.9 11 0 0 0 2.5-45.5 2.5-48.7 0-3.2 3.3-30.7 3.2-37.4-0.1-6.6-3.6-9.1-3.6-9.1z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s29",
    d: "m250.2 167.8c-0.1 0-0.2-0.1-0.2-0.1 0-0.1 0-1.1 0-2.5 0.1-0.9 0.7-11.7 1.1-19.6 0.2-3.7 0.3-6.8 0.4-7.8 0-1.5 0.1-6.1 0.2-11 0-6 0.1-12.8 0.3-15.5 0.2-5 1-12 1-12.1 0-0.1 0.1-0.1 0.2-0.1 0.1 0 0.1 0.1 0.1 0.1 0 0.1-0.7 7.1-1 12.1-0.1 2.7-0.2 9.5-0.3 15.5-0.1 4.9-0.1 9.5-0.2 11-0.1 1-0.2 4.1-0.4 7.8-0.4 7.9-1 18.7-1 19.6-0.1 1.4 0 2.4 0 2.4 0 0.1-0.1 0.2-0.2 0.2z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s27",
    d: "m241.4 33.5c-9.3-8.4-25.6 0.3-19.7 16 6 15.7 13.9 38 13.9 38 0 0 3.9 2.4 8.4 1 1-0.3 0-10.1 0-10.1 0 0 5.5 9.7 6.9 9.1 8.4-3.9 16.6-16.6 16.6-16.6 0 0-21.8-33.5-26.1-37.4z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m147.5 95.7c-0.2 0-0.3-0.2-0.3-0.3 0-0.2 0.7-4 1.5-5.9 0.7-1.8 2-3 2-3.1 0.2-0.1 0.3-0.1 0.5 0 0.1 0.1 0.1 0.3-0.1 0.4 0 0.1-1.2 1.3-1.9 3-0.8 1.7-1.4 5.6-1.4 5.7 0 0.1-0.2 0.2-0.3 0.2z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m85.7 97.5v77h4.2v-77z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m197.2 97.5v77h4.2v-77z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m135.5 121.9v70.5h4.1v-70.5z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m243.8 121.9v70.5h4.2v-70.5z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s30",
    d: "m252.5 126.9h-114.9l-55.1-30.3v-3.7l114.9 3.7 55.1 26.6z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s31",
    d: "m252.5 123.2h-114.9l-55.1-30.3h114.9z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m74.8 58.5c-9 20.8-15.3 18.1-18.8 34.3-0.8 3.4-6.5 22.4-6.5 22.4l-34.9 18.4c0 0 0.3 5 1 6.5 0.8 2 5.3 8.2 5.3 8.2 0 0 33.7-18.3 36.4-20.9 2.7-2.7 9-13.4 15.8-28.6 0.8 8.3-4.2 29.3-6 37.2-0.7 2.9-11.1 37.6-11.1 37.6 3 1.8 17.4 1.1 17.4 1.1l18.2-92.4c0 0 0.5-16.4 1.3-19.2 0.7-2.9-17.3-6.7-18.1-4.6z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m69.1 70.4l-1.1 1.8c0 0 3.6 1.8 6.5 2.9 2.9 1 5.8 1.7 8.6 2.3 2.8 0.6 8.7 0.6 8.7 0.6l0.1-1.9c0 0-16.7-1.8-22.8-5.7z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m74.2 75.6l1.5-3 1.7 0.7-1.5 2.8z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m86.2 78.4l0.3-3.3h1.8l-0.3 3.1z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s9",
    d: "m79.1 38.7c6.4-9.8 21.3-5.5 19.6 10-1.6 15.6-3.8 15.8-2.6 23.9 0.5 3.5-4.2 3.5-4.2 3.5 0 0-7.4-0.6-13.3-1.8-4.7-0.9-9.7-4.5-9.7-4.5 0 0-3.8-1.6-0.9-5.9 3-4.4 9.4-22.8 11.1-25.2z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s9",
    d: "m87 37.9c3.6-0.2 17.8 12.8 23.3 15.9 3.4 2 29.3 12.8 25.2 16.9-0.6 0.6-2.1 4.2-5.1 3.5-6.2-1.3-16.8-8.8-25.8-13.6-11-6-20.4-14-21.3-17-0.6-1.9 0-5.5 3.7-5.7z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m115.9 189.6c-0.6-0.3-1-0.9-1.1-1.6-0.2-1.2 1.1-6.8 1.5-8.8 0.7-3.1-7.2-1-7.2-1 0 0 0.4 11.6-0.4 13-0.5 0.7 14.3 1.9 11.2 0.5-0.9-0.4-2.9-1.5-4-2.1z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m108.5 191.1c0.3-0.8 0.4-1.2 0.6-1.7 0.1 0.3 0.5 0.7 1.3 1.1 0.8 0.4 8.4 2.7 9.5 1.2 3 0.7 6.2 2.5 5.6 3.1-2 2-12.6 0.3-16.1-0.5-0.4-0.1-0.9-0.4-1-0.8-0.2-0.7-0.2-1.6 0.1-2.4z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m104.5 189.6c-1.1-1.6-0.3-4.7 0.3-9.8 0.3-3.2-7.7-1.3-7.7-1.3 0 0 1.1 11.3 0.2 12.7-0.5 0.7 14.3 1.9 11.3 0.5-0.9-0.4-3.3-1-4.1-2.1z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m97.2 191.1c0.3-0.8 0.4-1.2 0.5-1.7 0.2 0.3 0.6 0.7 1.3 1.1 0.8 0.4 8.5 2.7 9.6 1.2 3 0.7 6.2 2.5 5.6 3.1-2 2-12.6 0.3-16.1-0.5-0.5-0.1-0.9-0.4-1-0.8-0.2-0.7-0.3-1.6 0.1-2.4z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m120.2 85q0-0.6 0-0.6c0 0 1.7-3 3.2-6.8 0.2-0.5 5-9.9 4.9-17-0.1-3.2-1.7-7.6-3.4-9.7-1.7-2.1-6.3-4.7-13-0.8-6.8 4-9.9 23.2-13.6 30.3 1 0.6 8.4 3.2 11.9 4.1 6.1 1.4 6.4 0.3 10 0.5z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m108.4 84.5c-3.5-0.8-9.1-3.5-10.1-4.1q-0.5 0.9-0.9 1.5c-3.6 4.7-6.9 13.9-8.1 20-1.4 7.4 8.4 85.3 8.4 86.8l7.1-8.8c0-0.3 5.4-61.4 5.4-61.4 1.2 11.7-1.9 55.7-1 68.7l6.1-3.2c0.9-4.2 7.3-33.5 7.9-38.2 2.3-18.1-2.3-33.8-2.9-42.7-0.3-5.3-5.8-17.1-11.9-18.6z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s32",
    d: "m122.2 104.8c-0.8-7.6-2.1-13.4-2-20.4 0 0-1.3 1.1-7.3-0.1-8.3-1.7-14.3-4.6-14.3-4.6q-0.6 1.3-1.2 2.2c-3.6 4.7-6.9 13.9-8.1 20-1 5.4-1.5 47.7-1.5 71.7 0.9 0 12.7-1.4 17.4 0.8 9.6 4.4 18.2 1.2 22.4-2.2-0.3-12.5-4.5-58.5-5.4-67.4z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m146.9 110.4c0 0 1.7 1 2.5 1.4 1.6 0.8 4 1.3 4.2 0.9 0.2-0.7-1.9-0.7-2-1.2-0.1-0.5 5.5 0.9 5.7 0.4 0.1-0.4-4.1-1.3-4.1-1.5 0-0.2 4.9 1.1 4.9 0.7 0-0.4-4.5-1.5-4.6-1.7-0.1-0.2 4 1 3.9 0.6-0.1-0.5-4.4-1.4-4.4-1.6-0.1-0.2 2.4 0.4 2.5 0 0.1-0.5-3.5-0.6-4.3-0.7-0.8-0.1-2.5-0.3-4 0-1.1 0.1-1.5 1.6-0.3 2.7z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m135.7 80.8c-3.6 2.3-7.1 2.5-9 2.4q0.8 1.6 1.6 3.2c6.2 12.2 17 25.1 20.3 24.8 6-0.6-10.4-24.6-12.9-30.4z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m168.8 85.8c1 0 6.7 0 7-0.4 0.3-0.3-1.7-0.6-1.7-0.6 0 0 3.2-0.1 3.3-0.5 0.1-0.5-0.2-0.5-0.2-0.5 0 0 0.8-0.1 0.8-0.6 0-0.6-3.1-0.4-3.1-0.4 0 0 2.4-0.3 2.4-0.6 0-0.3-1.2-0.6-2.8-0.5-1.6 0.1-2.6 0.1-2.6 0.1 0 0 2.1-0.2 2.1-0.5 0.1-0.4-0.2-0.8-2-0.6-1.7 0.3-3.7 1-4.5 0.7-0.8-0.2-2.2-1.3-2.5-1-0.4 0.3-1.8 2-1.5 2.7 0.4 0.7 4.3 2.7 5.3 2.7z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m119.4 38.4c0 0-1.4 6.9-3.2 10.2-0.8 1.3 5.4 2.2 5.4 1.2 0-2.1 1.8-9 1.8-9z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m136 81.5c-0.1-0.2-10.2-28.1-10.2-28.1-1.5-2.9-6.9 0-7.8 2.7-0.8 2.6 1 15.5 7.1 28.2 1.9 0.1 7.3-0.6 10.9-2.8z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m121.3 29.8c-2.1 0.3-3.8 2.1-4 4.2-0.2 3.2 0 4.9 1.4 6.6 1.5 1.7 4.6 3.2 6.5 2.8 1.4-0.3 3-1.7 3.1-3.8 0-1.5-0.2-2.4-0.2-3-0.1-1.5 0.2-6.9-2.8-7-1.2-0.1-2.7 0-4 0.2z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s18",
    d: "m125.2 39.7c0 0 1.6-0.1 2.7-0.2 0 0 0 1.1-1.1 1.2-1 0-1.6-1-1.6-1z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m124.8 36.3c0 0 0.4 0.3 0.1 0.9-0.4 0.5-1.1 0-1.1-0.3-0.1-0.3 0.2-0.5 0.2-0.5 0 0 0.3-0.3 0.8-0.1z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m116.5 48.4c0 0-1.3 0.4-0.2 1.8 1.1 1.5 6.3 5.9 8 5.3 0.9-0.3-1.8-6.5-2.7-6.9-0.9-0.4-5.1-0.2-5.1-0.2z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m123.1 36.7q-0.1 0-0.1-0.1 0-0.1 0.1-0.1c0 0 0.8-0.4 1.4-0.4 0.6 0 0.7 0.4 0.7 0.4q0 0.1-0.1 0.1-0.1 0.1-0.1 0c0 0-0.1-0.3-0.5-0.3-0.5 0-1.3 0.4-1.4 0.4z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m127.9 36.2c0 0 0.2 0.4 0 0.9-0.2 0.6-0.7 0.1-0.7-0.2 0-0.3 0.1-0.6 0.1-0.6 0 0 0.2-0.3 0.6-0.1z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m127.3 36.4h-0.1q0-0.1 0-0.2c0.2-0.1 0.6-0.4 0.8 0q0.1 0.1 0 0.2 0 0-0.1 0c-0.2-0.4-0.6 0-0.6 0z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m126.1 36.9c0-0.2 0.1-0.2 0.2-0.1 0.1 0.3 0.5 0.6 0.9 1 0.8 0.5 0.7 1.1-0.2 1-0.9-0.1-1-0.2-1-0.7 0-0.3 0-0.9 0.1-1.2z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m122 35.2q0 0-0.1 0 0-0.1 0.1-0.2c0.9-0.4 2-0.4 2.1-0.4q0.1 0 0.1 0.1 0 0.1-0.1 0.1c0 0-1.2 0-2 0.4z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m127.9 35.5h-0.1q-0.4-0.4-1-0.7-0.1 0-0.1-0.1 0.1-0.1 0.1-0.1 0.7 0.4 1.2 0.7 0 0.1 0 0.2z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m122.6 43.2h-0.1c0-0.1-1.4-0.6-1.9-0.9q-0.1-0.1 0-0.2 0-0.1 0.1 0c0.5 0.3 1.9 0.9 1.9 0.9q0.1 0 0.1 0.1-0.1 0.1-0.1 0.1z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m120 35.2c0 0 1.5-1 3-1.1 2.2-0.2 5.6 0.4 5.6 0.4 0 0 0.5-3.3-1.5-4.9-2-1.6-4.3-1.5-5.9-0.2-1.5 1.4-1.2 5.8-1.2 5.8z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m121.2 31.7c0 0 0 5.3-1.2 5.3-0.6-0.1-0.7-0.5-1.5-2.1-0.7-1.6-1.7-4-0.8-5.6 1.7-2.9 5.5-2.3 6.8-0.8z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m121.6 27.7c0 0-4.5-1.9-6.8 2.9-2.2 4.9 3 9.9 3 10.3-0.1 0.3 0.7 1.1 0.8 0.8 0.1-0.3 0.5-1.2 0.8-3.3 0.4-2.1-0.1-3.9 0-4.7 0-0.8 2.2-6 2.2-6z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m119.5 36.2c-0.2-0.5-0.5-0.8-0.8-1-0.4-0.1-0.9-0.1-1.2 0.9-0.6 1.9 1.6 4.5 2.3 3.1 0.5-0.9 0-2.3-0.3-3z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m119.2 38.9q-0.1 0-0.1-0.1c0.1-0.1 0.1-0.5 0-0.7-0.1 0-0.2 0-0.3 0-0.2 0-0.4 0.1-0.5-0.1-0.2-0.3-0.4-0.9-0.3-1.4 0-0.6 0.4-0.7 0.4-0.7q0.1 0 0.1 0 0.1 0.1 0 0.2c0 0-0.3 0.1-0.3 0.5-0.1 0.5 0.1 1 0.3 1.3 0 0 0.1 0 0.2 0 0.2 0 0.4-0.1 0.5 0.1 0.3 0.2 0.2 0.8 0.1 0.9q0 0-0.1 0z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m115.7 34.7c0 0-1.3-1.2-2.8-0.4-1.5 0.8-1.9 2-1 3.4 1 1.4 1.8 2.6 3.3 2.1 1.5-0.6 1.9-3.6 0.5-5.1z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m173.9 84c-1.7-2.6-25.7-10.8-32.1-14.2-0.4 1.8-1.5 6.5-4.8 9.2 12.7 5 38.8 7.8 36.9 5z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m98.1 90.2c1.1 0.7 1.7 0.1 1.7-2.2 0-0.4-0.5-0.6-0.9-0.4-0.8 0.8-1.8 1.9-0.8 2.6z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m101.5 149.2c0.1-0.4-0.3-0.8-0.7-0.6-1 0.4-2.4 1.1-1.6 2.1 0.8 1.1 1.5 0.7 2.3-1.5z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m120.9 148.1c0.4-1 0.8-2.5-0.4-2.6-1.4-0.1-1.6 0.6-0.5 2.7 0.2 0.4 0.8 0.3 0.9-0.1z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m106.5 139.5c0.1 1.1 0.5 2.6 1.6 2.1 1.3-0.6 1.1-1.3-0.8-2.6-0.4-0.3-0.9 0-0.8 0.5z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m120.3 130.1c-0.5-1.2-1.3-1.1-2.7 0.8-0.2 0.3 0 0.8 0.5 0.8 1.1-0.1 2.6-0.4 2.2-1.6z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m111.3 158.7c1.1 0.7 1.6 0.2 1.6-2.1 0-0.5-0.5-0.7-0.8-0.4-0.8 0.7-1.9 1.9-0.8 2.5z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m99.1 123.5c0.1-0.4-0.3-0.8-0.7-0.6-1 0.4-2.4 1.1-1.6 2.1 0.8 1.1 1.5 0.7 2.3-1.5z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m117.6 122.5c0.2 0.4 0.8 0.3 0.9-0.1 0.5-1 0.8-2.5-0.4-2.6-1.3-0.1-1.6 0.6-0.5 2.7z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m104.9 113.3c-0.4-0.3-0.9 0-0.8 0.5 0.1 1.1 0.5 2.6 1.7 2.1 1.2-0.6 1-1.3-0.9-2.6z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m115.3 105.2c-0.3 0.3 0 0.8 0.4 0.8 1.1-0.1 2.6-0.4 2.2-1.5-0.5-1.3-1.2-1.2-2.6 0.7z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m110.5 130.9c0-0.5-0.5-0.7-0.8-0.4-0.8 0.7-1.9 1.9-0.8 2.5 1.1 0.7 1.6 0.2 1.6-2.1z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m97 148.1c0.4-1 0.8-2.5-0.5-2.6-1.3-0.1-1.5 0.6-0.5 2.7 0.2 0.4 0.8 0.3 1-0.1z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m96.3 130.1c-0.5-1.2-1.2-1.1-2.6 0.8-0.3 0.3 0 0.8 0.4 0.8 1.1-0.1 2.6-0.4 2.2-1.6z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m89 156.6c0-0.5-0.5-0.7-0.9-0.4q-0.1 0.1-0.2 0.2-0.1 1.3-0.1 2.6c0.8 0.2 1.2-0.5 1.2-2.4z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m88.8 108.3c0.6 0.4 1.2-0.1 1.9-1.9 0.1-0.4-0.3-0.8-0.7-0.7-0.3 0.2-0.8 0.4-1.1 0.6q0 0.9-0.1 2z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m109.2 105.3c0.2 0.4 0.8 0.4 1 0 0.4-1 0.7-2.6-0.5-2.7-1.3-0.1-1.5 0.7-0.5 2.7z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m95.7 96.6c0.1 1.1 0.5 2.6 1.7 2.1 1.2-0.5 1-1.3-0.9-2.6-0.4-0.2-0.8 0.1-0.8 0.5z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m106.9 88c-0.3 0.4 0 0.9 0.4 0.8 1.1 0 2.6-0.3 2.2-1.5-0.5-1.2-1.2-1.1-2.6 0.7z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m102.2 113.7c0-0.4-0.6-0.6-0.9-0.4-0.8 0.8-1.9 1.9-0.8 2.6 1.1 0.7 1.7 0.1 1.7-2.2z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m117.7 91.7c0.1-0.4-0.3-0.8-0.7-0.7-1 0.4-2.4 1.2-1.6 2.2 0.8 1 1.5 0.7 2.3-1.5z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m121.3 151c0.8 1 1.5 0.7 2.3-1.5 0.1-0.4-0.3-0.8-0.7-0.6-1 0.3-2.4 1.1-1.6 2.1z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m121.5 174.1c0.4-1 0.8-2.5-0.5-2.6-1.3-0.1-1.5 0.6-0.4 2.6 0.2 0.4 0.7 0.4 0.9 0z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m108.7 167.5c1.2-0.5 1.1-1.3-0.9-2.5-0.3-0.3-0.8 0-0.8 0.4 0.2 1.1 0.6 2.6 1.7 2.1z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m120.8 156.1c-0.4-1.2-1.2-1.1-2.6 0.7-0.3 0.4 0 0.9 0.4 0.9 1.1-0.1 2.7-0.4 2.2-1.6z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m141.8 69.8q-0.7-0.4-1.1-0.7c-2-1.3-25.3-17.2-25.3-17.2-2.8-1.6-5.8 3.8-5.1 6.6 0.8 2.8 12.1 17.7 24.8 22.8 0 0 7.1-3.9 6.7-11.5z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m135.1 81.6q-0.1 0-0.1-0.1c-0.1 0-4.3-2.1-10.1-6-5.8-3.9-11.3-11.4-11.4-11.4-0.1-0.2 0-0.3 0.1-0.4 0.1-0.1 0.3-0.1 0.4 0 0.1 0.1 5.5 7.5 11.2 11.3 5.8 3.9 10 6 10 6 0.2 0.1 0.2 0.2 0.2 0.4q-0.1 0.2-0.3 0.2z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m128.5 61.1q-0.1 0-0.2 0l-9.1-6.2 0.4-0.5 9.1 6.2c0.1 0.1 0.1 0.3 0 0.4q0 0.1-0.2 0.1z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m122.9 79.4q-0.1 0-0.2 0c-0.1 0-0.2-0.2-0.1-0.4 0.4-1.1 1.5-3.9 2-4.2 0.2 0 0.4 0 0.4 0.1 0.1 0.2 0.1 0.4-0.1 0.4-0.2 0.2-1.1 2.2-1.8 3.9q-0.1 0.2-0.2 0.2z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m91.3 26.6c0 0-0.5 1.7-1 3.2-0.6 1.6-1.2 3-2 4.4-0.3 0.5 5 3.3 5.1 2.2 0.3-2.4 1.1-8.8 1.1-8.8z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m94.5 18.8c-1.9 0-3.5 1.4-3.9 3.3-0.5 2.7-0.5 4.2 0.6 5.8 1.2 1.6 2.4 3.3 4.6 3.5 2.4 0.2 3.6-1.1 3.9-3 0.1-1.2-0.2-2.7-0.1-3.2 0.2-1.1 0.9-5.9-1.6-6.3-1.1-0.1-2.4-0.2-3.5-0.1z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s18",
    d: "m96.4 27.7c0 0 1.6-0.1 2.7 0 0 0 0 1-1 1-1 0-1.7-1-1.7-1z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m96 24.6c0 0 0.3 0.3-0.1 0.8-0.3 0.4-1-0.1-1-0.4 0-0.2 0.2-0.5 0.2-0.5 0 0 0.3-0.2 0.9 0.1z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m99.2 24.9c0 0 0.2 0.3-0.1 0.8-0.3 0.4-0.8 0-0.8-0.3 0-0.2 0.2-0.5 0.2-0.5 0 0 0.3-0.2 0.7 0z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m96.2 24.9q0 0-0.1 0c0-0.1 0-0.3-0.4-0.3-0.4-0.1-1.1 0.2-1.1 0.2q-0.1 0-0.2-0.1 0 0 0.1-0.1c0 0 0.8-0.2 1.3-0.2 0.5 0.1 0.5 0.4 0.5 0.4q0 0.1-0.1 0.1z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m99.3 25.1l-0.1-0.1c-0.2-0.3-0.7 0-0.7 0q-0.1 0-0.1-0.1-0.1 0 0-0.1c0.2-0.1 0.7-0.2 1 0.1q0 0.1 0 0.1z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m97.5 25.4c0-0.1 0.1-0.2 0.1-0.1 0.2 0.2 0.5 0.6 0.9 0.8 0.7 0.5 0.7 1-0.2 0.9-0.8 0-0.9-0.1-0.9-0.6 0-0.3 0-0.7 0.1-1z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m94.6 23.5q0 0-0.1 0 0-0.1 0.1-0.1c0.8-0.3 1.8-0.2 1.8-0.2q0.1 0 0.1 0.1 0 0.1-0.1 0.1c0 0-1-0.1-1.8 0.1z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m99.7 24.3h-0.1q-0.3-0.3-0.9-0.7 0 0 0-0.1 0.1-0.1 0.1 0 0.6 0.3 0.9 0.7v0.1z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m94.5 31.2h-0.1c0 0-1.3-0.5-2.2-1.5-0.1-0.1-0.1-0.2 0-0.2 0.1-0.1 0.2-0.1 0.2 0 0.9 0.9 2.1 1.4 2.1 1.4 0.1 0 0.2 0.1 0.1 0.2q0 0.1-0.1 0.1z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m91.5 24.4c-0.1-0.4-0.3-0.7-0.6-0.9-0.3-0.1-0.8-0.1-1.1 0.7-0.7 1.6 0.9 4.1 1.6 2.9 0.5-0.8 0.3-2 0.1-2.7z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m91 26.9h-0.1c0-0.1-0.1-0.2-0.1-0.2 0.1-0.2 0.2-0.5 0.1-0.5 0-0.1-0.1-0.1-0.2-0.1-0.2 0-0.4 0-0.5-0.2-0.1-0.2-0.2-0.8-0.1-1.3 0-0.4 0.3-0.6 0.4-0.6 0.1 0 0.2 0 0.3 0.1 0 0.1-0.1 0.2-0.2 0.2 0 0-0.1 0.1-0.2 0.4-0.1 0.4 0 0.9 0.1 1.1 0 0 0.1 0 0.2 0 0.1 0 0.3 0 0.4 0.1 0.3 0.3 0.1 0.8 0.1 0.9q-0.1 0.1-0.2 0.1z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s21",
    d: "m97.7 20.2c0 0-3 0.8-4.3 3.1-1.3 2.2-2.8 7.6-4.6 10.4-1.7 2.8-13.6 12.2-13.6 12.2 0 0 0.9-5.7 8.4-14.9 2-2.4 2.8-10.7 6-13.3 2.2-1.8 4.6-0.6 6.5 0.4 1.9 1 1.6 2.1 1.6 2.1z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s21",
    d: "m97.7 20.2c0 0 2 0.8 2.5 3.1 0 0 0.6-2-0.4-3.7-0.9-1.7-2.9-3.6-5.3-3.2-2.4 0.3-1.7 1.1-1.2 1.4 0.4 0.2 4.4 2.4 4.4 2.4z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s33",
    d: "m73.1 99.1q-0.1 0-0.2 0c-0.1-0.1-0.2-0.3-0.1-0.4 0.3-0.9 3.7-8.9 5.1-10 0.8-0.7 2.6-7.5 3.6-11.7 0-0.1 0.2-0.2 0.4-0.2 0.2 0 0.3 0.2 0.2 0.4 0 0-0.6 2.7-1.4 5.5-1.5 5.8-2.2 6.4-2.4 6.6-1 0.8-3.9 7.2-4.9 9.6-0.1 0.2-0.2 0.2-0.3 0.2z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s33",
    d: "m78.1 89.3c-0.2 0-0.3 0-0.3-0.2-0.1-0.1 0-0.3 0.1-0.4 1.9-0.9 3.5-1.9 3.6-2.3 0.1-0.8 2.2-8.1 2.3-8.5 0.1-0.1 0.3-0.2 0.4-0.2 0.2 0.1 0.3 0.2 0.3 0.4-0.1 0.1-2.2 7.7-2.4 8.5 0 0.2-0.3 0.7-2.1 1.7-0.9 0.6-1.7 1-1.8 1q-0.1 0-0.1 0z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s33",
    d: "m46.9 119.6q-0.1 0-0.1-0.1c-0.2-0.1-0.2-0.3-0.1-0.5 0 0 2.2-3 2.7-4.9 0.1-0.2 0.3-0.3 0.5-0.2 0.1 0 0.2 0.2 0.2 0.4-0.6 2-2.8 5-2.9 5.1q-0.1 0.1-0.3 0.2z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s10",
    d: "m97.7 56.8q-0.1 0-0.2-0.1c0 0-2-1.3-4.8-3.3-2.8-2-8.9-8.3-9.2-8.6-0.1-0.1-0.1-0.4 0-0.5 0.2-0.1 0.4-0.1 0.5 0 0.1 0.1 6.3 6.6 9.1 8.5 2.8 2.1 4.8 3.4 4.8 3.4 0.2 0.1 0.2 0.3 0.1 0.4q-0.1 0.2-0.3 0.2z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s26",
    d: "m157.6 5.6c0 0-3.3 1-2.5 1.2 0.7 0.3 5.3-0.8 5.3-1.3-0.1-0.5-2.1-0.2-2.8 0.1z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s34",
    d: "m223.6 34.4c0 0-0.4-1.5 1.8-3 2.3-1.6 5-1.9 6.3-1.1 1.3 0.7 2.9 5.3 2.8 5.6-0.1 0.2-9.8 3.8-10.4 3.4-0.6-0.4-1.3-2.8-0.5-4.9z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s18",
    d: "m231.1 31.6c0 0 0.8 0.1 0.5 5.4-0.3 5.3 2.5 21.3 1.9 21.7-0.6 0.4-10.9-20.9-8.4-24 0 0 2.2-1.8 3.8-2.6 1.7-0.7 2.2-0.5 2.4-0.4"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m140.9 24.2c3.8-1.4 7.2 13.9 9.6 23.9 1 4.5 2.3 8.1 2.4 8.4 0.5 0.7 21.9 20.7 20.3 23.2-1.6 2.4-20.7-4.3-28.9-13.1-7.1-7.7-13.5-38.6-3.4-42.4z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m171 76.2c0.6 0.2 2.3 1.8 3 2.1 1.6 0.6 4.1 0.6 3.8 1.1-0.4 0.9-2.3 0.6-2.8 1-0.4 0.4 4 3.8 3.7 4.3-0.3 0.6-3.4-2.1-3.6-1.9-0.2 0.1 3.7 3 3.4 3.3-0.3 0.4-3.8-2.3-4-2.2-0.3 0.1 3.1 2.4 2.7 2.7-0.4 0.3-3.6-2.4-3.8-2.2-0.2 0.1 1.7 1.6 1.4 2.1-0.3 0.5-2.4-2.4-3-2.9-0.6-0.6-1.6-1.9-2.3-3.4-0.5-1 1-4.1 1.5-4z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m179.5 75.2c-0.6 0.1-2.2 1.7-2.9 2-1.6 0.7-4.2 0.6-3.9 1.2 0.4 0.8 2.4 0.5 2.8 0.9 0.4 0.4-3.9 3.8-3.6 4.4 0.3 0.5 3.3-2.2 3.5-2 0.2 0.2-3.7 3-3.3 3.4 0.3 0.3 3.7-2.4 4-2.3 0.2 0.1-3.1 2.5-2.8 2.7 0.5 0.4 3.6-2.3 3.8-2.2 0.2 0.1-1.7 1.7-1.4 2.1 0.3 0.5 2.5-2.3 3-2.9 0.6-0.5 3-3.1 3.7-4.6 0.5-1-2.4-2.9-2.9-2.7z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s18",
    d: "m147.8 20.4c0 0 1.3-2.5 1.6-2.5 0.3 0.1 3.5 3.6 3.9 3.9 0.5 0.3 0.9-0.2 0.9-0.3 0-0.1 0.3-1.6 0.3-1.6l1.6 2.5-0.7 2.8-1.9-1.7-2.5 1.2z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s18",
    d: "m137.6 55.1q0.4 1.3 0.9 2.6c2.1 0.2 8.8-0.9 13.4-4.3q-0.4-1.1-0.7-2.4c-1 0.6-2.4 1.2-4 1.8-3.9 1.2-7.8 1.9-9.6 2.3z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s25",
    d: "m140.9 24.2c-6.9 2.6-6.7 18.8-3.3 30.9 1.8-0.4 5.7-1.1 9.6-2.3 1.6-0.5 3-1.2 4-1.8q-0.4-1.4-0.7-2.9c-2.4-10-5.8-25.3-9.6-23.9z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m175.4 92.4c0 0 0.2 1.7 0.4 2.3 0.5 1.5 1.9 3.3 2.7 3.1 1.2-0.4-0.9-1.6-0.2-2 0.6-0.4 3.9 3.8 4.7 3.5 0.7-0.2-2-3.2-1.7-3.3 0.3-0.2 2.9 3.5 3.5 3.2 0.5-0.3-2-3.6-1.8-3.8 0.1-0.2 2.3 3 2.8 2.6 0.5-0.4-2.2-3.4-1.9-3.6 0.2-0.2 1.7 1.7 2.4 1.4 0.7-0.2-2.5-2.4-3-2.9-0.6-0.6-2-1.6-3.7-2.3-1.3-0.5-3.7 0.3-4.2 1.8z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m202.4 102.3c0 0-2.2 1.1-3.1 1.5-2.1 0.9-5 1.5-5.2 1-0.2-0.9 2.4-0.8 2.5-1.4 0.2-0.6-6.8 0.9-6.9 0.4-0.2-0.6 5-1.5 5-1.7 0-0.3-6 1.1-5.9 0.7 0-0.5 5.5-1.7 5.7-1.9 0.1-0.3-5 1-4.8 0.5 0.1-0.5 5.4-1.4 5.5-1.7 0.1-0.2-3 0.4-3.1-0.1-0.1-0.5 4.2-0.6 5.3-0.7 1-0.1 3-0.2 4.8 0.1 1.3 0.3 1.8 2 0.2 3.3z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m184.8 77.8c-0.1 0-2.5 0-3.5 0.1-2.2 0.2-5.1 1-5 1.6 0.1 0.8 2.4-0.5 2.8 0 0.4 0.4-6.5 2.3-6.3 2.9 0.1 0.6 5.1-1 5.2-0.8 0.2 0.2-5.8 1.7-5.6 2.1 0.3 0.4 5.7-1.1 6-1 0.2 0.2-4.9 1.4-4.5 1.7 0.4 0.4 5.4-1.1 5.6-1 0.2 0.2-2.8 1.1-2.6 1.6 0.1 0.5 4-1.5 4.9-1.9 1-0.3 2.9-1.2 4.3-2.3 1.1-0.8 0.7-2.6-1.4-3z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s28",
    d: "m153.9 58.6q-0.1 0-0.2 0c-1.3-1.4-1.6-3.8-1.6-3.9-0.1-0.1 0-0.2 0.1-0.3 0.2 0 0.3 0.1 0.3 0.2 0 0 0.3 2.4 1.5 3.7 0.1 0.1 0.1 0.2 0 0.3q-0.1 0-0.1 0z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s20",
    d: "m151.2 51.2c-0.1 0-0.2 0-0.3-0.2 0-0.1-3.5-16.2-4.9-20.6-1.5-4.3-3.7-5.7-3.7-5.7-0.1 0-0.2-0.2-0.1-0.3 0.1-0.1 0.2-0.2 0.3-0.1 0.1 0.1 2.4 1.5 3.9 5.9 1.5 4.4 5 20.6 5 20.7 0.1 0.2 0 0.3-0.2 0.3z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m227.1 23.6c0 0 0.7 2.3 1.6 4.4 0.7 1.6 2.1 3.3 2 3.9-0.2 0.6-3.9 4-4.7 3.6-0.9-0.4-2.4-8-2.4-8z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m223.5 16.9c1.8 0.1 3.4 1.5 3.7 3.4 0.4 2.7 0.4 5.3 0 6.2-0.9 1.7-5.4 3.1-7.3 2.6-1.2-0.4-1.5-1.5-1.7-3.4-0.1-1.2 0.1-2.3 0-2.8 0-1.3-0.7-5.6 1.8-5.9 1.1-0.1 2.3-0.2 3.5-0.1z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m222.2 18.3c0-0.1 2.3 0.1 3.1 0.9 0.7 0.6 0.4 3.2 1 3.8 0.5 0.7 2 0.6 2.5 0.2 1.2-1.1 0.9-4.2 0.8-4.9-0.5-2.6-1.5-2.8-3-3.2-1.6-0.3-5.4 2-4.4 3.1z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s18",
    d: "m221.9 25.2c0 0-1.7-0.1-2.9 0 0 0 0 1.3 1.1 1.3 1.1 0 1.8-1.3 1.8-1.3z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m223.4 21.7q0.1 0 0.1 0 0-0.1-0.1-0.1c0-0.1-0.6-0.2-1-0.1-0.4 0-0.6 0-0.6 0q-0.1 0.1 0 0.2 0 0.1 0.1 0 0 0 0.5 0c0.4-0.1 1 0 1 0z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m219.6 21.8q0.1 0 0.1-0.1 0-0.1-0.1-0.1c0 0-0.7 0-1.2 0q-0.1 0.1-0.1 0.1 0.1 0.1 0.1 0.1c0.5-0.1 1.2 0 1.2 0z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m222.4 21.6c-0.3 0-0.5 0.3-0.4 0.6 0 0.2 0.1 0.4 0.4 0.4 0.6 0.1 0.6-0.8 0.6-0.9-0.1-0.1-0.3-0.2-0.6-0.1z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m219.2 21.8c-0.3-0.3-0.7 0-0.7 0.4 0.1 0.3 0.2 0.5 0.4 0.5 0.5 0.1 0.5-0.8 0.4-0.9q0 0-0.1-0.1z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m223.6 20.6q0.1 0 0.1 0 0-0.1-0.1-0.2c-1.1-0.2-2.2-0.1-2.2-0.1q-0.1 0-0.1 0.1 0 0.1 0.1 0.1c0 0 1.1-0.1 2.2 0.1z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m218.3 20.7l1.2-0.2q0.1-0.1 0.1-0.1 0-0.1-0.1-0.1l-1.3 0.2q0 0 0 0.1 0 0.1 0.1 0.1z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m227.7 22.1q0.1 0 0.1-0.1 0-0.1-0.1-0.1l-3.9-0.2q-0.1 0-0.1 0.1 0 0.1 0.1 0.1l3.9 0.2z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m222.8 24.4c-1-0.1-1.9-0.9-2-1.8-0.1-0.5 0-0.9 0.3-1.2 0.3-0.3 0.8-0.5 1.3-0.4 1 0.1 1.9 0.9 2 1.8 0 0.4-0.1 0.8-0.4 1.1-0.2 0.3-0.6 0.4-1 0.5q-0.1 0-0.3 0zm-1.4-2.9c-0.3 0.3-0.4 0.6-0.3 1 0.1 0.9 0.9 1.6 1.8 1.7 0.4 0 0.8-0.1 1.1-0.4 0.2-0.2 0.3-0.6 0.3-1-0.1-0.8-0.9-1.6-1.8-1.6q-0.2 0-0.3 0-0.5 0-0.8 0.3z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m218.4 24.1c-0.7-0.1-1.5-0.9-1.6-1.8 0-0.5 0.1-1 0.4-1.3 0.2-0.2 0.6-0.4 0.9-0.3 0.8 0 1.5 0.8 1.6 1.7 0 0.5-0.1 1-0.4 1.3q-0.3 0.3-0.7 0.4-0.1 0-0.2 0zm-1-3c-0.3 0.3-0.4 0.7-0.4 1.2 0.1 0.8 0.8 1.5 1.4 1.6q0.5 0 0.8-0.3c0.2-0.3 0.3-0.7 0.3-1.1-0.1-0.9-0.7-1.6-1.4-1.6q-0.1 0-0.2 0-0.3 0-0.5 0.2z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m220.9 22.5q0.1-0.1 0-0.1c0-0.1-0.7-0.7-1.4-0.2q-0.1 0.1 0 0.2 0 0 0.1 0c0.6-0.4 1.2 0.1 1.2 0.1z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m226.9 21.7c0.2-0.3 0.5-0.6 0.9-0.7 0.4-0.1 0.9-0.1 1.1 0.6 0.6 1.3-1.3 3.4-2.1 2.7q-0.1-0.1-0.1-0.3c-0.2-0.9-0.1-1.7 0.2-2.3z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m227.2 23.8q0.1 0 0.1-0.1c0 0-0.1-0.4 0-0.5 0.1 0 0.2 0 0.4 0 0.1 0 0.3 0 0.5-0.2 0.1-0.2 0.3-0.6 0.2-1 0-0.5-0.4-0.6-0.4-0.6q-0.1 0-0.1 0.1 0 0.1 0.1 0.1c0 0 0.2 0.1 0.3 0.4 0 0.4-0.2 0.8-0.3 0.9-0.1 0.1-0.2 0.1-0.3 0.1-0.2 0-0.4 0-0.5 0.1-0.3 0.2-0.1 0.6-0.1 0.7q0 0 0.1 0z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m220.6 22.6c-0.1-0.1-0.2-0.1-0.2 0-0.2 0.2-0.5 0.6-1 0.9-0.7 0.5-0.6 1 0.4 0.8 0.9-0.1 1-0.2 1-0.7 0-0.2-0.2-0.7-0.2-1z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m223.9 18.1c0 0-2.2 0.8-3.5 0.9-1.3 0.1-2.9-0.4-3.1-0.7-0.7-1.2-1.1-3.4 1-4.1 2-0.6 1.5 0.7 2.2 0.9 0.2 0.1 0.4 0.1 1.1 0 2.5-0.2 8.3-1.2 6.4 0.8-1.8 1.9-4.1 2.2-4.1 2.2z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m222.8 29.1q-0.2 0-0.2-0.1c0-0.1 0-0.2 0.1-0.2 2.7-0.5 3.5-1.5 3.5-1.5 0-0.1 0.1-0.1 0.2 0 0.1 0 0.1 0.1 0 0.2 0 0.1-0.8 1.1-3.6 1.6z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m234.4 34l-22.6 24.3c0 0-31.3 19.7-29.3 22.5 1.9 2.8 27.2-8.8 32.3-11.6 8.4-4.6 25.6-25.8 26.4-29.1 1-4.6-3.8-8-6.8-6.1z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m200.9 102.5c2.9 1.7 13.7-19.1 16.5-24.3q0.7-1.2 1.4-2.7l-11-1.6c-2.9 8-9.3 27.2-6.9 28.6z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m220.5 15.1c0 0 3.2 1.2 4.7 3.6 1.7 2.7 2.9 6.2 3.1 6.9l1.2-1c0 0 1.9 1 2.9 0.6 0.9-0.4 0.6-6.2-1.3-8.6-1.4-1.8-3.2-3.1-6.3-2.7-0.6 0.1-1.6-0.3-2.2-0.1-1.3 0.5-2.1 0.5-2.1 1.3z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s27",
    d: "m234.4 34l-21.1 22.7c0.8 2.3 4.5 8.9 9.1 10.2 8.7-7.9 18.2-24.1 18.8-26.8 1-4.6-3.8-8-6.8-6.1z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m226.6 62.9q-0.1 0-0.2-0.1c-0.2-0.1-0.2-0.3-0.1-0.4 0.1-0.1 3.1-3.7 7.4-9.8 4.4-6 6.7-11.4 6.7-11.4 0.1-0.2 0.3-0.3 0.5-0.2 0.1 0.1 0.2 0.3 0.2 0.4-0.1 0.1-2.4 5.5-6.8 11.6-4.4 6.1-7.4 9.8-7.4 9.8q-0.2 0.1-0.3 0.1z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m215.6 54.5q0 0-0.1-0.1c-0.2 0-0.2-0.3-0.1-0.4 0-0.1 1.4-2.3 3.2-3.5 1.7-1.1 7.2-7.8 7.3-7.8 0.1-0.2 0.3-0.2 0.4-0.1 0.2 0.2 0.2 0.4 0.1 0.5-0.2 0.3-5.7 6.8-7.4 8-1.7 1.1-3.1 3.2-3.1 3.2q-0.1 0.2-0.3 0.2z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m243.8 79.6c-0.1 0-0.3-0.1-0.3-0.3-0.5-2.6-10-19.4-10.1-19.5-0.1-0.2-0.1-0.4 0.1-0.5 0.2-0.1 0.4 0 0.5 0.1 0.4 0.7 9.7 17 10.2 19.8 0 0.2-0.1 0.3-0.3 0.4z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s29",
    d: "m256.6 104.2c-0.2 0-0.4-0.1-0.4-0.3 0-0.1-1.7-5.5-2.7-8.4-1-2.7-5.4-5.9-5.4-5.9-0.2-0.1-0.3-0.4-0.1-0.6 0.1-0.2 0.4-0.3 0.6-0.1 0.2 0.1 4.7 3.3 5.7 6.3 1 2.9 2.7 8.3 2.8 8.4 0 0.2-0.1 0.5-0.4 0.6q0 0-0.1 0z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s29",
    d: "m270.3 84.8h-0.1c-5.5-1.2-7.6-5.2-7.7-5.3-0.1-0.3-0.1-0.5 0.2-0.7 0.2-0.1 0.5 0 0.6 0.2 0 0.1 2.1 3.8 7.1 4.9 0.2 0.1 0.4 0.3 0.3 0.6 0 0.2-0.2 0.3-0.4 0.3z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s29",
    d: "m284 163.4q-0.1 0-0.1-0.1c-0.1-0.2-1.9-12.7-4.2-22.6-0.5-2.2-1.3-8.3-2.1-14.8-1.1-8.3-2.3-17.7-3.1-20.1-1.4-4.1-5.5-21.2-5.6-21.4 0-0.1 0.1-0.2 0.2-0.2 0 0 0.1 0 0.2 0.1 0 0.2 4.1 17.3 5.5 21.4 0.8 2.4 2 11.4 3.1 20.2 0.8 6.4 1.6 12.5 2.1 14.7 2.3 10 4.2 22.5 4.2 22.6 0 0.1-0.1 0.2-0.2 0.2z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s18",
    d: "m166.4 102.6h16l10 12.4-17 1z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m172.4 113.3h-12.1l2.3-11.6h12z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s20",
    d: "m137.6 55.3q-0.1 0-0.2-0.1c-1.8-4.4-2.2-9-2.3-12.1-0.1-3.4 0.3-5.7 0.3-5.7 0-0.2 0.2-0.3 0.3-0.2 0.1 0 0.2 0.1 0.2 0.2 0 0.1-1.4 9.3 1.9 17.6 0.1 0.1 0 0.2-0.1 0.3z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m184.3 78q0 0-0.1-0.1c0-0.1 0-0.2 0-0.2 0 0 1.3-1.2 2.8-2.7 1.6-1.5 13.3-9.4 13.8-9.7 0.1-0.1 0.2-0.1 0.2 0 0.1 0.1 0.1 0.2 0 0.3-0.1 0-12.2 8.2-13.7 9.7-1.6 1.5-2.8 2.6-2.8 2.6q-0.1 0.1-0.2 0.1z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s19",
    d: "m178.2 76.4q0 0-0.1-0.1c0 0-0.1-0.1 0-0.2 1.7-2 10.3-12.1 10.8-12.3 0.5-0.2 5.2-6 5.8-7.2 0.6-0.9 1.5-2 1.5-2.1 0.1 0 0.2 0 0.3 0 0 0.1 0 0.2 0 0.3 0 0-0.9 1.1-1.5 2-0.5 0.9-5.3 7-5.9 7.3-0.5 0.3-6.7 7.5-10.7 12.2q-0.1 0.1-0.2 0.1zm10.9-12.3z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s21",
    d: "m208.6 101.6l1.2 13.4c0 0.8 2.2 1.4 4.8 1.5 2.7 0 4.9-0.6 4.9-1.4l1.6-13.4c-2.2 1.7-10.4 1.5-12.5-0.1z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s35",
    d: "m221.3 101.2v-2h-0.6c-1.1-0.8-3.3-1.3-5.8-1.4-2.6 0-4.8 0.5-5.8 1.2h-0.7v2c0 1.2 2.8 2.3 6.4 2.3 3.6 0.1 6.5-0.9 6.5-2.1z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s18",
    d: "m214.8 101.3c-3.5 0-6.4-1-6.4-2.3 0-1.2 2.9-2.2 6.5-2.1 3.5 0 6.4 1 6.4 2.3 0 1.2-2.9 2.2-6.5 2.1z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s35",
    d: "m219.9 98.6v-1.6h-0.5c-0.8-0.6-2.5-1-4.5-1-2-0.1-3.7 0.3-4.6 0.9h-0.5v1.5c0 1 2.3 1.8 5 1.9 2.8 0 5.1-0.8 5.1-1.7z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s18",
    d: "m214.9 98.7c-2.8 0-5.1-0.8-5.1-1.8 0.1-1 2.3-1.7 5.1-1.7 2.8 0 5.1 0.9 5 1.8 0 1-2.2 1.7-5 1.7z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s32",
    d: "m188 115.3c1.9 0.1 3.5-1.9 4.2-3.8 0.5-1.6 0.3-2.8-0.6-3.4-2.1-1.1-4.4 1.3-4.7 1.5-0.3 0.4-0.3 0.9 0 1.3 0.4 0.3 1 0.3 1.3 0 0.5-0.6 1.8-1.6 2.5-1.2 0.1 0.2 0 1.2-0.7 2.4-0.6 0.9-1.4 1.5-2 1.5l-0.7-0.2c-0.4-0.1-0.9 0.1-1 0.6-0.2 0.5 0.1 1 0.6 1.1l0.8 0.2q0.2 0 0.3 0z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s32",
    d: "m183.1 105.8l5.8 0.3-2.5 13.2c0 0.4-1.7 0.7-3.7 0.7-2.1-0.1-3.7-0.5-3.7-0.9l-1.8-13.3z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s21",
    d: "m177.2 105.8c0 0.7 2.6 1.3 5.8 1.4 3.3 0.1 5.9-0.4 5.9-1.1 0.1-0.6-2.6-1.2-5.8-1.3-3.2-0.1-5.9 0.3-5.9 1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeProgram);
export default __webpack_public_path__ + "static/media/home-program.9846ad3a36375b4f1dcb0731d0070415.svg";
export { ForwardRef as ReactComponent };